import { render, staticRenderFns } from "./AsiaReportsHome.vue?vue&type=template&id=1fb94f73"
import script from "./AsiaReportsHome.vue?vue&type=script&lang=js"
export * from "./AsiaReportsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports